// eslint-disable-next-line @typescript-eslint/triple-slash-reference -- ambient global.d.ts has no runtime JS counterpart to import
/// <reference path="./global.d.ts" />
import { logData } from "@jetblue/dotcom-fe-logger";
import { subscribeToUserConsentDecision } from "@jetblue/dotcom-trust-arc";

const state = {
  coreReady: Promise.withResolvers<undefined>(),
  lastAppliedConsent: undefined as boolean | undefined,
  readyScripts: new Set<"dynamic" | "static">(),
};

// eslint-disable-next-line unicorn/no-top-level-side-effects -- Handle script rejection before any Login consumer subscribes.
void state.coreReady.promise.catch(() => {
  // The original promise remains rejected for Login to handle.
});

export const ensureDynamicYieldGlobal = () => {
  // eslint-disable-next-line unicorn/no-global-object-property-assignment -- 3rd party stuff
  const dy = (globalThis.DY ??= {});

  return dy;
};
export const updateDynamicYieldConsent = (isAccepted: boolean) => {
  void logData({ message: "DY consent updated", newValue: isAccepted });
  ensureDynamicYieldGlobal().userActiveConsent = {
    accepted: isAccepted,
  };
  state.lastAppliedConsent = isAccepted;
  globalThis.DYO?.ActiveConsent?.updateConsentAcceptedStatus?.(isAccepted);
};
export const subscribeDynamicYieldConsent = () =>
  subscribeToUserConsentDecision((decision) => {
    const consent = decision.functional;
    if (typeof consent !== "boolean" || consent === state.lastAppliedConsent) {
      return;
    }
    updateDynamicYieldConsent(consent);
  }, "Dynamic Yield");
export const notifyDynamicYieldScriptReady = (kind: "dynamic" | "static") => {
  state.readyScripts.add(kind);

  if (state.readyScripts.size < 2) {
    return;
  }

  if (typeof globalThis.DY?.API !== "function") {
    state.coreReady.reject(
      new Error("Dynamic Yield API unavailable after core scripts loaded"),
    );
    return;
  }

  state.coreReady.resolve(undefined);
};
export const notifyDynamicYieldScriptError = (error: unknown) => {
  state.coreReady.reject(error);
};
export const whenDynamicYieldCoreReady = (): Promise<void> =>
  state.coreReady.promise;
